import { render, staticRenderFns } from "./SessionOverview.vue?vue&type=template&id=274730f4&scoped=true"
import script from "./SessionOverview.vue?vue&type=script&lang=js"
export * from "./SessionOverview.vue?vue&type=script&lang=js"
import style0 from "./SessionOverview.vue?vue&type=style&index=0&id=274730f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274730f4",
  null
  
)

export default component.exports